"use client";
import Link from "next/link";
import { useParams } from "next/navigation";
import { type ComponentProps } from "react";
import { publicStorePath } from "@/lib/storefront/public-url";

export const LinkWithChannel = ({
	href,
	...props
}: Omit<ComponentProps<typeof Link>, "href"> & { href: string }) => {
	const { locale } = useParams<{ locale?: string }>();

	if (!href.startsWith("/")) {
		return <Link {...props} href={href} />;
	}

	const loc = locale ?? "de";
	const hrefWithLocale = publicStorePath(loc, href);
	return <Link {...props} href={hrefWithLocale} />;
};
